import http from "../services/http";
import { __api_getTzLn } from "./endpoints";

export const getSettings = data => {
    return http.Request("GET", __api_getTzLn, data, true);
}
